const $ = jQuery;

export class AdvancedForm {

  public fields?: HTMLElement[];
  public fieldRules?: { [ key: string ]: HTMLElement[] };
  public $triggerField?: JQuery;

  constructor( public formElement: HTMLFormElement ) {
    this.basicUploader();
    this.features();
  }

  basicUploader() {
    const inputSelector = 'input[type="file"]';

    $( '.acf-image-uploader[data-uploader="basic"]', this.formElement ).each( ( index, fieldWrap ) => {
      let $fieldWrap = $( fieldWrap );
      let $fileinput = $fieldWrap.find( inputSelector );

      // Add mime types to input
      let mimes: string = $fileinput.closest( '.acf-image-uploader' ).data( 'mime_types' );
      // Add dots before extensions
      mimes = mimes.split( ',' ).map( ext => '.' + ext ).join( ',' );
      $fileinput.attr( 'accept', mimes );

      // Add image preview
      $fieldWrap.on( 'change', ( $fileinput as any ).selector, function ( this: HTMLInputElement, e ) {
        let files = this.files || [];
        if ( files.length === 0 ) { return }

        let image_url = URL.createObjectURL( files[ 0 ] );
        $fieldWrap.find( 'img' ).attr( 'src', image_url );
        $fieldWrap.addClass( 'has-value' );
      } );

      // Remove image
      $fieldWrap.on( 'click', 'a[data-name="remove"]', function ( e ) {
        // Reset the file input field
        let input = $fieldWrap.find( inputSelector ).get( 0 );
        input.outerHTML = input.outerHTML;
      } );
    } );
  }

  features() {
    const features: string[] = $( this.formElement ).data( 'features' ).split( ' ' );

    features.forEach( feature => {
      switch ( feature ) {

        // Add a "Save Draft" button to the submission area
        case 'Draft':
          let $submitArea = $( this.formElement ).find( '.af-submit' );
          let $draftSubmit = $submitArea.find( ':submit' ).clone();
          $draftSubmit
            .addClass( 'af-submit-draft' )
            .attr( 'id', 'save-post' ) // ACF looks for this ID to skip validation
            .text( 'Save Draft' )
            .on( 'click', () => {
              $( this.formElement ).append( $( '<input type="hidden" name="draft" value="1" />' ) );
            } );
          $submitArea.find( ':submit:first' ).after( $draftSubmit );
          break;

      }
    } );
  }
}
